import React, { Component, Fragment } from "react";
import NovoForm from "./Form"
import CardForm from "./CardForm"
import Menu from "./Menu";
import NomeUnidade from "../../UI/NomeUnidade";
import api from "../../../services/api";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Form",
            user: {},
            categoriaSelecionada: 0
        }
    }

    async componentDidMount() {
        await this.consultarMetasMensaisSTI();
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.categoriaSelecionada !== this.state.categoriaSelecionada) {
            await this.consultarMetasMensaisSTI();
        }
    }

    escolheCategoria = (categoria) => {
        document.forms[0].reset()
        this.setState({ categoriaSelecionada: categoria })
    }

    exibeConteudoForm = (selecionado) => {
        let formularios =  [
            {
                categoria: "CONSULTORIA EM TECNOLOGIA",
                nomes: [
                    "CONSULTORIA EM TECNOLOGIA",
                    "CONSULTORIA EM PROCESSOS PRODUTIVOS",
                    "CONSULTORIA PARA ATENDIMENTO DE LEGISLAÇÕES, NORMAS E REGULAMENTOS TÉCNICOS"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
                nomes: [
                    "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
                    "SERVIÇOS OPERACIONAIS"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
                nomes: [
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO DE PRODUTO ",
                    "PROJETOS EM PDI DE PRODUTO",
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO DE PROCESSO",
                    "PROJETOS EM PDI DE PROCESSO"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "METROLOGIA",
                nomes: [
                    "METROLOGIA",
                    "ENSAIOS",
                    "CALIBRAÇÃO"
                ],
                indicadoresnome: ["Número de Atendimento", "Calibrações", "Ensaios", "Relatórios/Laudos", "receita", "despesa"],
                indicadoresid: ["numeroAtendimento", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"],
            },
            {
                categoria: "SERVIÇOS COMPLEMENTARES",
                nomes: [
                    "SERVIÇOS COMPLEMENTARES",
                    "CONSULTORIA EM GESTÃO EMPRESARIAL (SERVIÇOS INTERNOS SEM RECEITA)"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "despesa"],
            }
            
        ]
        return formularios[selecionado]
    }

    onSubmit = async (event) => {
        
        event.preventDefault();
        let valores = Array.from(event.target).map(valor => valor.value ? Number(valor.value) : 0);

        let formularioSelecionado = this.exibeConteudoForm(this.state.categoriaSelecionada);

        let inicio = 0;
        let fim = this.verificaFim(formularioSelecionado);
        let incremento = fim;

        let metas = formularioSelecionado.nomes.map(categoria => {
            let valoresDaCategoria = valores.slice(inicio, fim);
            let val = {
                unidade: this.props.match.params.unidade.toUpperCase(),
                categoria: categoria,
                valores: this.retornaValoresMetas(formularioSelecionado, valoresDaCategoria)
            }
            inicio = fim;
            fim += incremento;
            return val
        });

        let linhaDeAtuacao = this.somaLinhaDeAtuacao(metas)
        metas[0].valores = linhaDeAtuacao

        let status = await api.put(`/sti/metasmensais`, metas);
        if(status.data.status === "ok") window.showNotification('Cadastrado com sucesso', 'success');
        else window.showNotification(status.data.status || 'Erro na atualização', 'danger');

        this.setState({ metas: metas });
        
    }

    somaLinhaDeAtuacao = (metas) => {
        let somaLinhaDeAtuacao = {}
        metas.forEach((valor, indice) => {
            if(indice !== 0) {

                let val = valor.valores
                Object.keys(val).map((indicador, i) => {
                    somaLinhaDeAtuacao[indicador] = val[indicador].map((v, ind) => {
                        try {
                            return v + somaLinhaDeAtuacao[indicador][ind]
                        } catch (error) {
                            return v + 0
                        }
                        
                    });
                });

            }
        });
        return somaLinhaDeAtuacao;
    }

    retornaValoresMetas = (formularioSelecionado, valoresDaCategoria) => {
        let valoresMetas;
        if(formularioSelecionado.categoria === "METROLOGIA") {
            valoresMetas = {
                numeroAtendimento: valoresDaCategoria.slice(0, 12),
                calibracoes: valoresDaCategoria.slice(12, 24),
                ensaios: valoresDaCategoria.slice(24, 36),
                relatoriosELaudos: valoresDaCategoria.slice(36, 48),
                receita: valoresDaCategoria.slice(48, 60),
                despesa: valoresDaCategoria.slice(60, 72)
            }
        }
        else if(formularioSelecionado.categoria === "SERVIÇOS COMPLEMENTARES") {
            valoresMetas = {
                numeroAtendimento: valoresDaCategoria.slice(0, 12),
                horasTecnicas: valoresDaCategoria.slice(12, 24),
                despesa: valoresDaCategoria.slice(24, 36)
            }
        }
        else {
            valoresMetas = {
                numeroAtendimento: valoresDaCategoria.slice(0, 12),
                horasTecnicas: valoresDaCategoria.slice(12, 24),
                receita: valoresDaCategoria.slice(24, 36),
                despesa: valoresDaCategoria.slice(36, 48)
            }
        }

        return valoresMetas;

    }

    verificaFim = (formularioSelecionado) => {
        let fim;
        if(formularioSelecionado.categoria === "METROLOGIA") {
            fim = 72;
        }
        else if(formularioSelecionado.categoria === "SERVIÇOS COMPLEMENTARES") {
            fim = 36;
        }
        else {
            fim = 48
        }
        return fim;
    }

    consultarMetasMensaisSTI = async () => {
        let metas = await api.get("/sti/metasmensais");
        metas = metas.data.metasMensaisSTI;
        this.setState({ metas })
    }

    render() {

        let { categoriaSelecionada } = this.state;
        let formularioSelecionado = this.exibeConteudoForm(categoriaSelecionada);
        let { indicadoresnome, indicadoresid } = formularioSelecionado;
        let metasDaUnidade = this.state.metas && this.state.metas.filter(v => v.unidade === this.props.match.params.unidade.toUpperCase());

        return (
            <Fragment>

                <NomeUnidade unidade={"Metas Mensais - STI"}/>

                <div className="content">

                    <Menu escolheCategoria={this.escolheCategoria} categoriaSelecionada={categoriaSelecionada} />

                    <CardForm produto={formularioSelecionado.categoria} onSubmit={this.onSubmit}>
                        {formularioSelecionado.nomes.map(categoria => {
                            let disabled = categoria === formularioSelecionado.categoria ? true : false;
                            return(
                                <Fragment>
                                    <NovoForm 
                                        categoria={categoria}
                                        id={categoria}
                                        indicadoresid={indicadoresid}
                                        indicadoresnome={indicadoresnome}
                                        metasDaUnidade={metasDaUnidade}
                                        formDisabled={disabled}
                                    />
                                    <hr />
                                </Fragment>
                            )
                        })}
                    </CardForm>

                </div>

            </Fragment>
        )
    }
}